import * as Sentry from "@sentry/react"
import { Icons } from "components/Icons/_Icons"
import { createRoot } from "react-dom/client"
import "./validation"
import "./polyfills"
import { redirectOldAppIfSwitched, rememberStay } from "app/switch/appSwitch"
import App from "./App"

// Errors go to GlitchTip (DKT-14). Personal-data baseline from bleuchaud-portal docs/evaluations/error-tracking.md.
if (import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.VITE_ENVIRONMENT?.toLowerCase(),
    tracesSampleRate: 0,
    dataCollection: {
      userInfo: false,
      cookies: false,
      urlQueryParams: false,
      httpBodies: [],
      httpHeaders: { request: { allow: ["user-agent", "content-type"] }, response: false },
    },
  })
}

// Users switched to the beta go there, unless they came back with "Terug naar het oude Docket"
rememberStay(location.search)
redirectOldAppIfSwitched()

const rootElement = document.getElementById("root")!
const svgElement = document.getElementById("svg")!

createRoot(rootElement).render(
  <Sentry.ErrorBoundary>
    <App />
  </Sentry.ErrorBoundary>,
)
createRoot(svgElement).render(<Icons />)
